module.exports = __webpack_public_path__ + "static/media/1.49030850.png";